import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Bar } from "react-chartjs-2";
import { BarElement, CategoryScale, Chart as ChartJS, Legend, LinearScale, Title, Tooltip } from "chart.js";
import Loader from '../../components/Loader';
import axios from 'axios';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const Dashboard = () => {
  const [loading, setLoading] = useState(false);
  const [year, setYear] = useState(0);
  const [month, setMonth] = useState('');
  const [count_users, setCountUsers] = useState(0);
  const [count_drivers, setCountDrivers] = useState(0);
  const [count_partners, setCountPartners] = useState(0);
  const [count_packages, setCountPackages] = useState(0);
  const [count_tickets, setCountTickets] = useState(0);
  const [count_units, setCountUnits] = useState(0);
  const [total_ticket, setTotalTicket] = useState(0);
  const [total_package, setTotalPackage] = useState(0);
  const [data_tickets, setDataTickets] = useState([]);
  const [data_ticketsvent, setDataTicketsvent] = useState([]);
  const [data_packages, setDataPackages] = useState([]);
  const [earningsByUnit, setEarningsByUnit] = useState({
    labels: [],
    datasets: []
  });
  const [selectedEarningsBranch, setSelectedEarningsBranch] = useState(null);
const [earningsStartDate, setEarningsStartDate] = useState(null);
const [earningsEndDate, setEarningsEndDate] = useState(null);
  const ENDPOINT = process.env.REACT_APP_URL_ENDPOINT;

  // Estados para las gráficas
  const [ticketsByDestination, setTicketsByDestination] = useState({
    labels: [],
    datasets: []
  });
  const [paymentMethods, setPaymentMethods] = useState({
    labels: [],
    datasets: []
  });
  const [tripsByDriver, setTripsByDriver] = useState({
    labels: [],
    datasets: []
  });
  const [popularTimes, setPopularTimes] = useState({
    labels: [],
    datasets: []
  });

  // Estados para el filtro de sucursal
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [branches, setBranches] = useState([]);

  // Estados para el filtro de fechas en el encabezado
  const [showDateFilter, setShowDateFilter] = useState(true);
  const [filterYear, setFilterYear] = useState(new Date().getFullYear());
  const [filterMonth, setFilterMonth] = useState(new Date().getMonth() + 1);

  useEffect(() => {
    const current = new Date();
    const year = current.getFullYear()
    setYear(year);
    const months = new Array("Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre");
    setMonth(months[current.getMonth()]);
    loadDashboardData(year, current.getMonth() + 1);
    getBranches();
    getEarningsByUnit();
  }, []);

  // Nueva función que carga todos los datos del dashboard con los filtros
  const loadDashboardData = (year, month) => {
    getCountDashboard(year, month);
    getGraphicTickets(year);
    getGraphicTicketsvent(year);
    getGraphicPackages(year);
    getTicketsByDestination(month, year);
    getPaymentMethods(month, year);
    getTripsByDriver(month, year);    
    getPopularTimes(null, month, year);
  };

  const getCountDashboard = async (year = null, month = null) => {
    setLoading(true);
    await axios.get(ENDPOINT + 'get-count-dashboard', {
      params: {
        year: year || new Date().getFullYear(),
        month: month || (new Date().getMonth() + 1)
      }
    })
      .then(response => {
        setCountUsers(response.data.data.countUsers);
        setCountDrivers(response.data.data.countDrivers);
        setCountPartners(response.data.data.countPartners);
        setCountPackages(response.data.data.countPackages);
        setCountTickets(response.data.data.countTickets);
        setCountUnits(response.data.data.countUnits);
        setTotalTicket(response.data.data.totalTicket);
        setTotalPackage(response.data.data.totalPackage);
        setLoading(false);
      }).catch(function (error) {
        console.log(error)
      });
  };



  const getEarningsByUnit = async (branchId = null, startDate = null, endDate = null) => {
    try {
      setLoading(true);
      
      let url = ENDPOINT + 'get-earnings-by-unit';
      const user = JSON.parse(localStorage.getItem("dataUser"));
      
      const params = new URLSearchParams();
      params.append('user_id', user.user_id);
      
      if (branchId) {
        params.append('branch_id', branchId);
      }
      
      // Establecer fechas por defecto (mes actual) si no se proporcionan
      const currentDate = new Date();
      const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
      
      if (!startDate) {
        startDate = firstDayOfMonth;
      }
      if (!endDate) {
        endDate = currentDate;
      }
      
      params.append('start_date', format(startDate, "yyyy-MM-dd"));
      params.append('end_date', format(endDate, "yyyy-MM-dd"));
      
      const response = await axios.get(`${url}?${params.toString()}`);
      
      if (response.data.res) {
        const units = response.data.data.map(item => item.unit_name);
        const earnings = response.data.data.map(item => item.total_earnings);
        
        setEarningsByUnit({
          labels: units,
          datasets: [{
            label: branchId ? `Ganancias por Unidad - Sucursal ${branchId}` : 'Ganancias por Unidad',
            data: earnings,
            backgroundColor: [
              '#3a7ca5', '#2f6690', '#254e70', '#1a365d', 
              '#0f1a2a', '#4da8da', '#007cc7', '#005b9f',
              '#003d66', '#001f33', '#16425b', '#2e5a78',
              '#457b9d', '#1d3557', '#e63946', '#f1faee',
              '#a8dadc', '#457b9d', '#1d3557', '#e63946'
            ],
            borderColor: '#fff',
            borderWidth: 1
          }]
        });
      }
    } catch (error) {
      console.error('Error fetching earnings by unit:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleEarningsBranchFilter = (branchId) => {
    setSelectedEarningsBranch(branchId);
    getEarningsByUnit(branchId, earningsStartDate, earningsEndDate);
  };
  
  // Añadir esta función para limpiar el filtro
  const clearEarningsFilter = () => {
    setSelectedEarningsBranch(null);
    setEarningsStartDate(null);
    setEarningsEndDate(null);
    getEarningsByUnit();
  };

  // Nueva función para aplicar el filtro de fechas global
  const handleDateFilterChange = (newYear, newMonth) => {
    setFilterYear(newYear);
    setFilterMonth(newMonth);
    // Actualizar todos los datos con las nuevas fechas
    loadDashboardData(newYear, newMonth);
  };

  // Función para limpiar el filtro de fechas
  const clearDateFilter = () => {
    const currentDate = new Date();
    setFilterYear(currentDate.getFullYear());
    setFilterMonth(currentDate.getMonth() + 1);
    loadDashboardData(currentDate.getFullYear(), currentDate.getMonth() + 1);
  };



  const getGraphicTickets = async (year = null) => {
    await axios.get(ENDPOINT + 'get-graphic-tickets', {
      params: {
        year: year || new Date().getFullYear()
      }
    })
      .then(response => {
        const data = Object.values(response.data.data)
        const dataMonths = [];
        data.forEach(element => {
          dataMonths.push(element.quanty)
        });
        setDataTickets(dataMonths);
      }).catch(function (error) {
        console.log(error)
      });
  };
  
  const getGraphicTicketsvent = async (year = null) => {
    await axios.get(ENDPOINT + 'get-graphic-ticketsvents', {
      params: {
        year: year || new Date().getFullYear()
      }
    })
      .then(response => {
        const data = Object.values(response.data.data)
        const dataMonths = [];
        data.forEach(element => {
          dataMonths.push(element.quanty)
        });
        setDataTicketsvent(dataMonths);
      }).catch(function (error) {
        console.log(error)
      });
  };

  const getTicketsByDestination = async (month = null, year = null) => {
    try {
        const response = await axios.get(ENDPOINT + 'get-graphic-tickets-by-destination', {
          params: {
            month: month || (new Date().getMonth() + 1),
            year: year || new Date().getFullYear()
          }
        });
        if (response.data.res) {
            const destinations = response.data.data.map(item => item.destination);
            const counts = response.data.data.map(item => item.count);

            setTicketsByDestination({
                labels: destinations,
                datasets: [{
                    label: 'Tickets por destino',
                    data: counts,
                    backgroundColor: [
                        '#3a7ca5', '#2f6690', '#254e70', '#1a365d', 
                        '#0f1a2a', '#4da8da', '#007cc7', '#005b9f',
                        '#003d66', '#001f33'
                    ],
                    borderColor: '#fff',
                    borderWidth: 1
                }]
            });
        }
    } catch (error) {
        console.error('Error fetching tickets by destination:', error);
    }
  };

  const getPaymentMethods = async (month = null, year = null) => {
    try {
      const response = await axios.get(ENDPOINT + 'get-graphic-payment-methods', {
        params: {
          month: month || (new Date().getMonth() + 1),
          year: year || new Date().getFullYear()
        }
      });
      if (response.data.res) {
        const labels = response.data.data.map(item => item.metodo);
        const data = response.data.data.map(item => item.cantidad);
        const colors = response.data.data.map(item => item.color);
        
        setPaymentMethods({
          labels: labels,
          datasets: [{
            label: 'Tickets por método de pago',
            data: data,
            backgroundColor: colors,
            borderColor: '#fff',
            borderWidth: 1
          }]
        });
      }
    } catch (error) {
      console.error('Error fetching payment methods:', error);
    }
  };

  const getTripsByDriver = async (month = null, year = null) => {
    try {
      const response = await axios.get(ENDPOINT + 'get-graphic-trips-by-driver', {
        params: {
          month: month || (new Date().getMonth() + 1),
          year: year || new Date().getFullYear()
        }
      });
      if (response.data.res) {
        const drivers = response.data.data.map(item => item.driver);
        const counts = response.data.data.map(item => item.count);

        setTripsByDriver({
          labels: drivers,
          datasets: [{
            label: 'Viajes por conductor',
            data: counts,
            backgroundColor: [
              '#3a7ca5', '#2f6690', '#254e70', '#1a365d', 
              '#0f1a2a', '#4da8da', '#007cc7', '#005b9f',
              '#003d66', '#001f33', '#16425b', '#2e5a78'
            ],
            borderColor: '#fff',
            borderWidth: 1
          }]
        });
      }
    } catch (error) {
      console.error('Error fetching trips by driver:', error);
    }
  };

  const getBranches = async () => {
    try {
      const response = await axios.get(ENDPOINT + 'get-branches');
      if (response.data.res) {
        setBranches(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching branches:', error);
    }
  };

  const getPopularTimes = async (branchId = null, month = null, year = null) => {
    try {
      let url = ENDPOINT + 'get-graphic-popular-times';
      const params = {
        month: month || (new Date().getMonth() + 1),
        year: year || new Date().getFullYear()
      };
      
      if (branchId) {
        params.branch_id = branchId;
      }

      const response = await axios.get(url, { params });
      if (response.data.res) {
        const times = response.data.data.map(item => 
          formatTime(item.time)
        );
        const ticketCounts = response.data.data.map(item => item.ticket_count);

        setPopularTimes({
          labels: times,
          datasets: [{
            label: branchId ? `Boletos vendidos - Sucursal ${branchId}` : 'Boletos vendidos',
            data: ticketCounts,
            backgroundColor: [
              '#3a7ca5', '#2f6690', '#254e70', '#1a365d', 
              '#0f1a2a', '#4da8da', '#007cc7', '#005b9f',
              '#003d66', '#001f33'
            ],
            borderColor: '#fff',
            borderWidth: 1
          }]
        });
      }
    } catch (error) {
      console.error('Error fetching popular times:', error);
    }
  };

  const handleBranchFilter = (branchId) => {
    setSelectedBranch(branchId);
    getPopularTimes(branchId, filterMonth, filterYear);
  };

  const clearFilter = () => {
    setSelectedBranch(null);
    getPopularTimes(null, filterMonth, filterYear);
  };

  const formatDate = (dateString) => {
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) {
        console.warn('Fecha inválida:', dateString);
        return 'Fecha inválida';
      }
      
      return date.toLocaleDateString('es-ES', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    } catch (error) {
      console.error('Error formateando fecha:', error, dateString);
      return 'Error fecha';
    }
  };

  const formatTime = (timeString) => {
    try {
      if (!timeString) return 'Hora no disponible';
      
      const timeParts = timeString.split(':');
      if (timeParts.length >= 2) {
        return `${timeParts[0]}:${timeParts[1]}`;
      }
      
      return timeString;
    } catch (error) {
      console.error('Error formateando hora:', error, timeString);
      return timeString;
    }
  };


  const format = (date, formatStr) => {
    if (!date) return '';
    
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    
    if (formatStr === 'yyyy-MM-dd') {
      return `${year}-${month}-${day}`;
    }
    
    return `${day}/${month}/${year}`;
  };


  const getGraphicPackages = async (year = null) => {
    await axios.get(ENDPOINT + 'get-graphic-packages', {
      params: {
        year: year || new Date().getFullYear()
      }
    })
      .then(response => {
        const data = Object.values(response.data.data)
        const dataMonths = [];
        data.forEach(element => {
          dataMonths.push(element.quanty)
        });
        setDataPackages(dataMonths);
      }).catch(function (error) {
        console.log(error)
      });
  };

  const destinationChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        legend: {
            position: 'right',
            labels: {
                boxWidth: 12,
                padding: 20,
                font: {
                    size: 12
                }
            }
        },
        tooltip: {
            callbacks: {
                label: function(context) {
                    return `${context.label}: ${context.raw} tickets`;
                }
            }
        }
    },
    scales: {
        y: {
            beginAtZero: true,
            ticks: {
                precision: 0
            }
        }
    }
  };


  const earningsByUnitOptions = {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: 'y',
    plugins: {
      legend: {
        position: 'top',
        labels: {
          boxWidth: 12,
          padding: 20,
          font: {
            size: 12
          }
        }
      },
      tooltip: {
        callbacks: {
          label: function(context) {
            return `$${context.raw.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
          },
          title: function(context) {
            return `Unidad: ${context[0].label}`;
          }
        }
      }
    },
    scales: {
      x: {
        beginAtZero: true,
        ticks: {
          precision: 0,
          callback: function(value) {
            return `$${value.toLocaleString('es-MX')}`;
          }
        },
        title: {
          display: true,
          text: 'Ganancias (MXN)'
        }
      },
      y: {
        title: {
          display: true,
          text: 'Unidades'
        }
      }
    }
  };


  const paymentMethodsOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'right',
        labels: {
          boxWidth: 12,
          padding: 20,
          font: {
            size: 12
          }
        }
      },
      tooltip: {
        callbacks: {
          label: function(context) {
            return `${context.label}: ${context.raw} tickets`;
          }
        }
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          precision: 0
        }
      }
    }
  };

  const tripsByDriverOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'right',
        labels: {
          boxWidth: 12,
          padding: 20,
          font: {
            size: 12
          }
        }
      },
      tooltip: {
        callbacks: {
          label: function(context) {
            return `${context.label}: ${context.raw} viajes`;
          }
        }
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          precision: 0
        }
      }
    }
  };

  const popularTimesOptions = {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: 'y',
    plugins: {
      legend: {
        position: 'top',
        labels: {
          boxWidth: 12,
          padding: 20,
          font: {
            size: 12
          }
        }
      },
      tooltip: {
        callbacks: {
          label: function(context) {
            return `${context.dataset.label}: ${context.raw}`;
          },
          title: function(context) {
            return `Horario: ${context[0].label}`;
          }
        }
      }
    },
    scales: {
      x: {
        beginAtZero: true,
        ticks: {
          precision: 0
        },
        title: {
          display: true,
          text: 'Cantidad de boletos'
        }
      },
      y: {
        title: {
          display: true,
          text: 'Horarios'
        }
      }
    }
  };

  const dataTrips = {
    labels: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
    datasets: [{
      label: "Boletos vendidas por mes",
      backgroundColor: '#008f39',
      borderColor: 'grey',
      borderWidth: 1,
      hoverBackgroundColor: '#008f39',
      hoverBorderColor: 'grey',
      data: data_tickets
    }]
  };

  const dataTripsventa = {
    labels: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
    datasets: [{
      label: "$ vendido por mes",
      backgroundColor: '#008f39',
      borderColor: 'grey',
      borderWidth: 1,
      hoverBackgroundColor: '#008f39',
      hoverBorderColor: 'grey',
      data: data_ticketsvent
    }]
  };

  const optionsTrips = {
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      legend: {
        display: true,
        labels: {
          color: '#343a40',
          font: {
            size: 14,
            weight: 'bold'
          }
        }
      },
      tooltip: {
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        titleColor: '#fff',
        bodyColor: '#fff',
        padding: 12,
        cornerRadius: 8,
        boxPadding: 6,
        usePointStyle: true,
        titleFont: {
          size: 13,
          weight: '600'
        },
        bodyFont: {
          size: 12
        }
      }
    },
    scales: {
      x: {
        grid: {
          display: false
        },
        ticks: {
          color: '#6c757d',
          font: {
            size: 11
          },
          maxRotation: 45,
          minRotation: 45
        }
      },
      y: {
        grid: {
          color: 'rgba(0, 0, 0, 0.05)',
          drawBorder: false
        },
        ticks: {
          color: '#6c757d',
          font: {
            size: 11
          },
          padding: 8,
          callback: function(value) {
             return Number(value).toLocaleString('es-MX'); // Cambio aquí
          }
        }
      }
    }
  };

  const optionsTripsventa = {
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      legend: {
        display: true,
        labels: {
          color: '#343a40',
          font: {
            size: 14,
            weight: 'bold'
          }
        }
      },
      tooltip: {
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        titleColor: '#fff',
        bodyColor: '#fff',
        padding: 12,
        cornerRadius: 8,
        boxPadding: 6,
        usePointStyle: true,
        titleFont: {
          size: 13,
          weight: '600'
        },
        bodyFont: {
          size: 12
        }
      }
    },
    scales: {
      x: {
        grid: {
          display: false
        },
        ticks: {
          color: '#6c757d',
          font: {
            size: 11
          },
          maxRotation: 45,
          minRotation: 45
        }
      },
      y: {
        grid: {
          color: 'rgba(0, 0, 0, 0.05)',
          drawBorder: false
        },
        ticks: {
          color: '#6c757d',
          font: {
            size: 11
          },
          padding: 8,
          callback: function(value) {
            return Number(value).toLocaleString('es-MX');
          }
        }
      }
    }
  };

  const dataPackages = {
    labels: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
    datasets: [{
      label: "Paquetes enviados por mes",
      backgroundColor: '#572364',
      borderColor: 'grey',
      borderWidth: 1,
      hoverBackgroundColor: '#572364',
      hoverBorderColor: 'grey',
      data: data_packages
    }]
  };

  const optionsPackages = {
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      legend: {
        display: true,
        labels: {
          color: '#343a40',
          font: {
            size: 14,
            weight: 'bold'
          }
        }
      },
      tooltip: {
        backgroundColor: '#343a40',
        titleColor: '#ffffff',
        bodyColor: '#ffffff',
        borderColor: '#ffffff',
        borderWidth: 1
      }
    },
    scales: {
      x: {
        ticks: {
          color: '#343a40',
          font: {
            size: 12
          }
        },
        grid: {
          display: false
        }
      },
      y: {
        ticks: {
          color: '#343a40',
          font: {
            size: 12
          }
        },
        grid: {
          color: '#e0e0e0'
        }
      }
    }
  };

  return (
    <>
      {loading && <Loader />}
      
      {/* Estilos CSS integrados */}
      <style>
        {`
          .dashboard-chart-actions {
            margin-left: auto;
            display: flex;
            align-items: center;
          }
          
          .dashboard-chart-actions .btn-group {
            margin-left: 10px;
          }
          
          .dashboard-chart-header {
            display: flex;
            align-items: center;
            width: 100%;
          }
          
          .dashboard-chart-info {
            flex: 1;
          }
          
          .branch-filter-buttons {
            display: flex;
            gap: 8px;
            margin-top: 10px;
            flex-wrap: wrap;
          }
          
          .branch-filter-button {
            padding: 4px 12px;
            border: 1px solid #ddd;
            border-radius: 4px;
            background: white;
            cursor: pointer;
            font-size: 12px;
            transition: all 0.3s ease;
          }
          
          .branch-filter-button.active {
            background: #007bff;
            color: white;
            border-color: #007bff;
          }
          
          .branch-filter-button:hover {
            background: #f8f9fa;
          }
          
          .branch-filter-button.active:hover {
            background: #0056b3;
          }

          /* Estilos para el filtro de fechas (mejorados) */
          .date-filter-container {
            background: linear-gradient(180deg, rgba(255,255,255,0.03), rgba(255,255,255,0.01));
            border-radius: 12px;
            padding: 12px;
            margin-top: 10px;
            border: 1px solid rgba(11,22,39,0.05);
            display: flex;
            gap: 12px;
            align-items: center;
            flex-wrap: wrap;
            box-shadow: 0 6px 18px rgba(11,22,39,0.06);
          }

          .date-filter-group {
            display: flex;
            gap: 8px;
            align-items: center;
          }

          .date-filter-group label {
            color: #e9f0f7;
            font-size: 13px;
            font-weight: 600;
            margin-right: 6px;
          }

          .custom-select { position: relative; display: inline-block; min-width: 160px; }
          .custom-select select {
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;
            width: 100%;
            padding: 8px 38px 8px 12px;
            border-radius: 8px;
            border: 1px solid rgba(12,20,39,0.06);
            background: #ffffff;
            color: #10243a;
            font-size: 14px;
            font-weight: 600;
            box-shadow: 0 2px 8px rgba(16,24,40,0.04);
            cursor: pointer;
            transition: all 0.18s ease;
          }

          .custom-select::after {
            content: '▼';
            position: absolute;
            right: 12px;
            top: 50%;
            transform: translateY(-50%);
            pointer-events: none;
            color: #6b7785;
            font-size: 12px;
          }

          .custom-select select:focus { outline: none; border-color: #3a86ff; box-shadow: 0 6px 18px rgba(58,134,255,0.12); }

          .date-filter-actions { display: flex; gap: 8px; margin-left: auto; align-items: center; }

          .btn-filter-apply { background: #0d6efd; color: white; border: none; padding: 8px 14px; border-radius: 8px; cursor: pointer; font-weight: 600; box-shadow: 0 6px 18px rgba(13,110,253,0.12); }
          .btn-filter-apply:hover { background: #0b5ed7; }

          .btn-filter-hide { background: transparent; border: 1px solid rgba(255,255,255,0.08); color: white; padding: 8px 12px; border-radius: 8px; cursor: pointer; font-size: 14px; }
          .btn-filter-hide i { font-size: 14px; }
          .btn-filter-hide:hover { background: rgba(255,255,255,0.04); border-color: rgba(255,255,255,0.15); }

          .btn-show-filter { background: rgba(255, 255, 255, 0.08); border: 1px solid rgba(255, 255, 255, 0.12); color: white; padding: 8px 12px; border-radius: 8px; cursor: pointer; font-size: 13px; transition: all 0.2s ease; }
          .btn-show-filter:hover { background: rgba(255,255,255,0.12); border-color: rgba(255,255,255,0.22); }
        `}
      </style>

      <section className="mt-3 dashboard-section">
        <div className="container-fluid">
          <div className="dashboard-header" style={{position: 'relative', paddingBottom: 110}}>
            <div className="dashboard-header-content">
              <h4 className="dashboard-title">
                <i className="fas fa-chart-line"></i>
                Dashboard Administrativo
              </h4>
              <p className="dashboard-description">
                Aquí encontrarás un resumen detallado de todas las operaciones y métricas importantes del sistema. 
        
              </p>
            </div>

            {/* Filtro integrado dentro del cuadro azul */}
            {showDateFilter && (
              <div className="date-filter-container" style={{position: 'absolute', left: 20, right: 20, bottom: 18, zIndex: 5}}>
                <div className="date-filter-group">
                  <label htmlFor="filter-year">Año:</label>
                  <div className="custom-select">
                    <select 
                      id="filter-year"
                      value={filterYear}
                      onChange={(e) => handleDateFilterChange(parseInt(e.target.value), filterMonth)}
                    >
                      {[2025, 2026].map(year => (
                        <option key={year} value={year}>{year}</option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="date-filter-group">
                  <label htmlFor="filter-month">Mes:</label>
                  <div className="custom-select">
                    <select 
                      id="filter-month"
                      value={filterMonth}
                      onChange={(e) => handleDateFilterChange(filterYear, parseInt(e.target.value))}
                    >
                      <option value={1}>Enero</option>
                      <option value={2}>Febrero</option>
                      <option value={3}>Marzo</option>
                      <option value={4}>Abril</option>
                      <option value={5}>Mayo</option>
                      <option value={6}>Junio</option>
                      <option value={7}>Julio</option>
                      <option value={8}>Agosto</option>
                      <option value={9}>Septiembre</option>
                      <option value={10}>Octubre</option>
                      <option value={11}>Noviembre</option>
                      <option value={12}>Diciembre</option>
                    </select>
                  </div>
                </div>

                <div className="date-filter-actions">
                  <button
                    className="btn-filter-apply"
                    onClick={() => loadDashboardData(filterYear, filterMonth)}
                    title="Aplicar filtros"
                  >
                    Aplicar
                  </button>
                  <button 
                    className="btn-filter-hide"
                    onClick={() => setShowDateFilter(false)}
                    title="Ocultar filtro"
                  >
                    <i className="fas fa-times"></i>
                  </button>
                </div>
              </div>
            )}

            {/* Botón para mostrar filtro si está oculto */}
            {!showDateFilter && (
              <button 
                className="btn-show-filter"
                onClick={() => setShowDateFilter(true)}
                style={{position: 'absolute', top: 18, right: 20}}
              >
                <i className="fas fa-calendar"></i> Mostrar filtro
              </button>
            )}
          </div>

          <div className="dashboard-stats-container">
            <div className="row g-3">
              {/* ... (las estadísticas se mantienen igual) ... */}            

{/* Estadísticas de Ingresos */}
<div className="col-lg-3 col-6">
  <div className="small-box gradient-style7 text-white box-shadow dashboard-card">
    <div className="inner">
      <div className="dashboard-metric-label">
        <i className="fas fa-money-bill-wave me-2"></i>
        Ingresos por Boletos
      </div>
      <h3>${Number(total_ticket).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} MXN</h3>
      <div className="dashboard-metric-detail">
        <p><i className="fas fa-chart-line me-1"></i> Total de ventas</p>
        <small><i className="fas fa-info-circle me-1"></i> En línea y taquilla</small>
      </div>
    </div>
    <div className="icon">
      <i className="fas fa-money-bill-wave" aria-hidden="true"></i>
    </div>
    <Link to="/listado-boletos" className="small-box-footer">
      Más información <i className="fas fa-arrow-circle-right" />
    </Link>
  </div>
</div>

<div className="col-lg-3 col-6">
  <div className="small-box gradient-style8 text-white box-shadow dashboard-card">
    <div className="inner">
      <div className="dashboard-metric-label">Ingresos por Paquetes</div>
      <h3>${Number(total_package).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} MXN</h3>
      <div className="dashboard-metric-detail">
        <p><i className="fas fa-chart-line me-1"></i>Ventas totales en {month}</p>
        <small><i className="fas fa-info-circle me-1"></i>Incluye ventas en línea y taquilla</small>
      </div>
    </div>
    <div className="icon">
      <i className="fas fa-dollar-sign" aria-hidden="true"></i>
    </div>
    <Link to="/listado-paquetes" className="small-box-footer">
      Más información <i className="fas fa-arrow-circle-right" />
    </Link>
  </div>
</div>

<div className="col-lg-3 col-6">
  <div className="small-box gradient-style1 text-white box-shadow dashboard-card">
    <div className="inner">
      <div className="dashboard-metric-label">Boletos Vendidos</div>
      <h3>{Number(count_tickets).toLocaleString('es-MX')}</h3>
      <div className="dashboard-metric-detail">
        <p><i className="fas fa-chart-line me-1"></i>Mes de {month}</p>
        <small><i className="fas fa-info-circle me-1"></i>Incluye ventas en línea y taquilla</small>
      </div>
    </div>
    <div className="icon">
      <i className="fa-solid fa-ticket" aria-hidden="true"></i>
    </div>
    <Link to="/agregar-boleto" className="small-box-footer">
      Más información <i className="fas fa-arrow-circle-right" />
    </Link>
  </div>
</div>

<div className="col-lg-3 col-6">
  <div className="small-box gradient-style2 text-white box-shadow dashboard-card">
    <div className="inner">
      <div className="dashboard-metric-label">Paquetes Enviados</div>
      <h3>{Number(count_packages).toLocaleString('es-MX')}</h3>
      <div className="dashboard-metric-detail">
        <p><i className="fas fa-chart-line me-1"></i>Mes de {month}</p>
        <small><i className="fas fa-info-circle me-1"></i>Incluye ventas en línea y taquilla</small>
      </div>
    </div>
    <div className="icon">
      <i className="fa-solid fa-box-open" aria-hidden="true"></i>
    </div>
    <Link to="/agregar-paquetes" className="small-box-footer">
      Más información <i className="fas fa-arrow-circle-right" />
    </Link>
  </div>
</div>

<div className="col-lg-3 col-6">
  <div className="small-box gradient-style3 text-white box-shadow dashboard-card">
    <div className="inner">
      <div className="dashboard-metric-label">Socios</div>
      <h3>{Number(count_partners).toLocaleString('es-MX')}</h3>
      <div className="dashboard-metric-detail">
        <small><i className="fas fa-info-circle me-1"></i>Socios activos en el sistema</small>
      </div>
    </div>
    <div className="icon">
      <i className="fas fa-users" aria-hidden="true"></i>
    </div>
    <Link to="/socios" className="small-box-footer">
      Más información <i className="fas fa-arrow-circle-right" />
    </Link>
  </div>
</div>

<div className="col-lg-3 col-6">
  <div className="small-box gradient-style4 text-white box-shadow dashboard-card">
    <div className="inner">
      <div className="dashboard-metric-label">Conductores</div>
      <h3>{Number(count_drivers).toLocaleString('es-MX')}</h3>
      <div className="dashboard-metric-detail">
        <small><i className="fas fa-info-circle me-1"></i>Conductores activos en el sistema</small>
      </div>
    </div>
    <div className="icon">
      <i className="fa-solid fa-user-group" aria-hidden="true"></i>
    </div>
    <Link to="/conductores" className="small-box-footer">
      Más información <i className="fas fa-arrow-circle-right" />
    </Link>
  </div>
</div>

<div className="col-lg-3 col-6">
  <div className="small-box gradient-style5 text-white box-shadow dashboard-card">
    <div className="inner">
      <div className="dashboard-metric-label">Usuarios</div>
      <h3>{Number(count_users).toLocaleString('es-MX')}</h3>
      <div className="dashboard-metric-detail">
        <small><i className="fas fa-info-circle me-1"></i>Usuarios registrados en el sistema</small>
      </div>
    </div>
    <div className="icon">
      <i className="fa-solid fa-users-gear" aria-hidden="true"></i>
    </div>
    <Link to="/usuarios" className="small-box-footer">
      Más información <i className="fas fa-arrow-circle-right" />
    </Link>
  </div>
</div>

<div className="col-lg-3 col-6">
  <div className="small-box gradient-style6 text-white box-shadow dashboard-card">
    <div className="inner">
      <div className="dashboard-metric-label">Unidades</div>
      <h3>{Number(count_units).toLocaleString('es-MX')}</h3>
      <div className="dashboard-metric-detail">
        <small><i className="fas fa-info-circle me-1"></i>Unidades activas en el sistema</small>
      </div>
    </div>
    <div className="icon">
      <i className="fa-solid fa-van-shuttle" aria-hidden="true"></i>
    </div>
    <Link to="/unidades" className="small-box-footer">
      Más información <i className="fas fa-arrow-circle-right" />
    </Link>
  </div>
</div>
            </div>
          </div>

          <div className="dashboard-charts-container">
            <div className="row">
              {/* ... (las otras gráficas se mantienen igual) ... */}
              <div className="col-sm-6">
                <div className="dashboard-chart-card">
                  <div className="card-header">
                    <div className="dashboard-chart-header">
                      <div className="dashboard-chart-icon">
                        <i className="fas fa-chart-bar"></i>
                      </div>
                      <div className="dashboard-chart-info">
                        <h6>Análisis de Boletos en {year}</h6>
                        <small className="dashboard-chart-subtitle">
                          Tendencias mensuales y comparativa de Boletos por Mes
                        </small>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="bar-chart-container">
                      <Bar data={dataTrips} options={optionsTrips} />
                    </div>
                    <div className="chart-legend">
                      <div className="chart-legend-item">
                        <span className="chart-legend-color" style={{backgroundColor: '#008f39'}}></span>
                        <span>Boletos mensuales</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-sm-6">
                <div className="dashboard-chart-card">
                  <div className="card-header">
                    <div className="dashboard-chart-header">
                      <div className="dashboard-chart-icon">
                        <i className="fas fa-chart-bar"></i>
                      </div>
                      <div className="dashboard-chart-info">
                        <h6>Análisis de Ventas $ en {year}</h6>
                        <small className="dashboard-chart-subtitle">
                          Tendencias mensuales y comparativa de ventas
                        </small>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="bar-chart-container">
                      <Bar data={dataTripsventa} options={optionsTripsventa} />
                    </div>
                    <div className="chart-legend">
                      <div className="chart-legend-item">
                        <span className="chart-legend-color" style={{backgroundColor: '#008f39'}}></span>
                        <span>Ventas mensuales</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-sm-6">
                <div className="dashboard-chart-card">
                  <div className="card-header">
                    <div className="dashboard-chart-header">
                      <div className="dashboard-chart-icon">
                        <i className="fas fa-box"></i>
                      </div>
                      <div className="dashboard-chart-info">
                        <h6>Análisis de Paquetes {year}</h6>
                        <small className="dashboard-chart-subtitle">
                          Tendencias mensuales y comparativa de envíos
                        </small>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="bar-chart-container">
                      <Bar data={dataPackages} options={optionsPackages} />
                    </div>
                    <div className="chart-legend">
                      <div className="chart-legend-item">
                        <span className="chart-legend-color" style={{backgroundColor: '#572364'}}></span>
                        <span>Envíos mensuales</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-sm-6">
                <div className="dashboard-chart-card">
                  <div className="card-header">
                    <div className="dashboard-chart-header">
                      <div className="dashboard-chart-icon">
                        <i className="fas fa-map-marked-alt"></i>
                      </div>
                      <div className="dashboard-chart-info">
                        <h6>Distribución de tickets por destino</h6>
                        <small className="dashboard-chart-subtitle">
                          Cantidad de tickets con estatus vendido por destino
                        </small>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="chart-container" style={{height: '300px'}}>
                      <Bar 
                        data={ticketsByDestination} 
                        options={destinationChartOptions} 
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-sm-6">
                <div className="dashboard-chart-card">
                  <div className="card-header">
                    <div className="dashboard-chart-header">
                      <div className="dashboard-chart-icon">
                        <i className="fas fa-credit-card"></i>
                      </div>
                      <div className="dashboard-chart-info">
                        <h6>Métodos de Pago - {month}</h6>
                        <small className="dashboard-chart-subtitle">
                          Distribución de tickets por método de pago
                        </small>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="chart-container" style={{height: '300px'}}>
                      <Bar 
                        data={paymentMethods} 
                        options={paymentMethodsOptions} 
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-sm-6">
                <div className="dashboard-chart-card">
                  <div className="card-header">
                    <div className="dashboard-chart-header">
                      <div className="dashboard-chart-icon">
                        <i className="fas fa-user-tie"></i>
                      </div>
                      <div className="dashboard-chart-info">
                        <h6>Viajes por Conductor - {month}</h6>
                        <small className="dashboard-chart-subtitle">
                          Distribución de viajes por conductor en el mes actual
                        </small>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="chart-container" style={{height: '300px'}}>
                      <Bar 
                        data={tripsByDriver} 
                        options={tripsByDriverOptions} 
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Gráfica de Horarios Más Populares con Filtros */}
              <div className="col-sm-6">
                <div className="dashboard-chart-card">
                  <div className="card-header">
                    <div className="dashboard-chart-header">
                      <div className="dashboard-chart-icon">
                        <i className="fas fa-clock"></i>
                      </div>
                      <div className="dashboard-chart-info">
                        <h6>Horarios Más Populares - {month}</h6>
                        <small className="dashboard-chart-subtitle">
                          Top 10 horarios con más boletos vendidos
                          {selectedBranch && ` - Sucursal ${selectedBranch}`}
                        </small>
                      </div>
                      <div className="dashboard-chart-actions">
                        <div className="btn-group btn-group-sm">
                          <button 
                            type="button" 
                            className={`btn ${selectedBranch === 1 ? 'btn-primary' : 'btn-outline-primary'}`}
                            onClick={() => handleBranchFilter(1)}
                          >
                            Oaxaca
                          </button>
                          <button 
                            type="button" 
                            className={`btn ${selectedBranch === 2 ? 'btn-primary' : 'btn-outline-primary'}`}
                            onClick={() => handleBranchFilter(2)}
                          >
                            Salina Cruz
                          </button>
                          <button 
                            type="button" 
                            className={`btn ${!selectedBranch ? 'btn-primary' : 'btn-outline-primary'}`}
                            onClick={clearFilter}
                          >
                            Todas
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="chart-container" style={{height: '400px'}}>
                      <Bar 
                        data={popularTimes} 
                        options={popularTimesOptions} 
                      />
                    </div>
                    {/* Botones de filtro adicionales en la parte inferior */}
                    <div className="branch-filter-buttons">
                      <button 
                        className={`branch-filter-button ${selectedBranch === 1 ? 'active' : ''}`}
                        onClick={() => handleBranchFilter(1)}
                      >
                        Oaxaca
                      </button>
                      <button 
                        className={`branch-filter-button ${selectedBranch === 2 ? 'active' : ''}`}
                        onClick={() => handleBranchFilter(2)}
                      >
                        Salina Cruz
                      </button>
                      <button 
                        className={`branch-filter-button ${!selectedBranch ? 'active' : ''}`}
                        onClick={clearFilter}
                      >
                        Todas las Sucursales
                      </button>
                    </div>
                  </div>
                </div>
              </div>


              
<div className="col-sm-6">
  <div className="dashboard-chart-card">
    <div className="card-header">
      <div className="dashboard-chart-header">
        <div className="dashboard-chart-icon">
          <i className="fas fa-chart-bar"></i>
        </div>
        <div className="dashboard-chart-info">
          <h6>Ganancias por Unidad</h6>
          <small className="dashboard-chart-subtitle">
            Distribución de ganancias por unidad
            {selectedEarningsBranch && ` - Sucursal ${selectedEarningsBranch}`}
          </small>
        </div>
        <div className="dashboard-chart-actions">
          <div className="btn-group btn-group-sm">
            <button 
              type="button" 
              className={`btn ${selectedEarningsBranch === 1 ? 'btn-primary' : 'btn-outline-primary'}`}
              onClick={() => handleEarningsBranchFilter(1)}
            >
              Oaxaca
            </button>
            <button 
              type="button" 
              className={`btn ${selectedEarningsBranch === 2 ? 'btn-primary' : 'btn-outline-primary'}`}
              onClick={() => handleEarningsBranchFilter(2)}
            >
              Salina Cruz
            </button>
            <button 
              type="button" 
              className={`btn ${!selectedEarningsBranch ? 'btn-primary' : 'btn-outline-primary'}`}
              onClick={clearEarningsFilter}
            >
              Todas
            </button>
          </div>
        </div>
      </div>
    </div>
    <div className="card-body">
      <div className="chart-container" style={{height: '400px'}}>
        <Bar 
          data={earningsByUnit} 
          options={earningsByUnitOptions} 
        />
      </div>
      {/* Botones de filtro adicionales en la parte inferior */}
      <div className="branch-filter-buttons">
        <button 
          className={`branch-filter-button ${selectedEarningsBranch === 1 ? 'active' : ''}`}
          onClick={() => handleEarningsBranchFilter(1)}
        >
          Oaxaca
        </button>
        <button 
          className={`branch-filter-button ${selectedEarningsBranch === 2 ? 'active' : ''}`}
          onClick={() => handleEarningsBranchFilter(2)}
        >
          Salina Cruz
        </button>
        <button 
          className={`branch-filter-button ${!selectedEarningsBranch ? 'active' : ''}`}
          onClick={clearEarningsFilter}
        >
          Todas las Sucursales
        </button>
      </div>
    </div>
  </div>
</div>



            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Dashboard;